/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * UXDS namespace name
 */
export const Namespace = {
  ProcessView: "process_view",
  FacilityMap: "facility_map",
} as const;
/**
 * UXDS namespace name
 */
export type Namespace = ClosedEnum<typeof Namespace>;

export type ListDocumentVersionsRequest = {
  /**
   * UXDS namespace name
   */
  namespace: Namespace;
  agentId: string;
};

/** @internal */
export const Namespace$inboundSchema: z.ZodNativeEnum<typeof Namespace> = z
  .nativeEnum(Namespace);
/** @internal */
export const Namespace$outboundSchema: z.ZodNativeEnum<typeof Namespace> =
  Namespace$inboundSchema;

/** @internal */
export const ListDocumentVersionsRequest$inboundSchema: z.ZodType<
  ListDocumentVersionsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  namespace: Namespace$inboundSchema,
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type ListDocumentVersionsRequest$Outbound = {
  namespace: string;
  agent_id: string;
};

/** @internal */
export const ListDocumentVersionsRequest$outboundSchema: z.ZodType<
  ListDocumentVersionsRequest$Outbound,
  z.ZodTypeDef,
  ListDocumentVersionsRequest
> = z.object({
  namespace: Namespace$outboundSchema,
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function listDocumentVersionsRequestToJSON(
  listDocumentVersionsRequest: ListDocumentVersionsRequest,
): string {
  return JSON.stringify(
    ListDocumentVersionsRequest$outboundSchema.parse(
      listDocumentVersionsRequest,
    ),
  );
}
export function listDocumentVersionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListDocumentVersionsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDocumentVersionsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDocumentVersionsRequest' from JSON`,
  );
}
